<template>
    <div class="stat">
        <div class="stat-icon">
            <i :class="icon" :style="style"></i>
        </div>
        <div class="stat-info">
            <span class="stat-title">{{ title }}</span>
            <span class="stat-value">{{ value }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Stat',
    props: ['title', 'value', 'icon', 'color'],
    computed: {
        style() {
            return 'color: ' + (this.color || '#000')
        }
    }
}
</script>

<style>
.stat {
    flex: 1;
    display: flex;
    border-radius: 15px;
    margin-right: 40px;
    margin-bottom: 5px;
    background: #616b70;
    font-style: normal;
    padding: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);
}

.stat-icon {
    display: flex;
    align-items: center;
}

.stat-icon i {
    font-size: 4rem;
}

.stat-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-size: 3rem;
}

.stat-title {
    font-size: 1rem;
    color: #ffff;
}

.stat-value {
    font-size: 1rem;
    color: #ffff;
}
</style>
